'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../languageHandler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SendButton = function (_React$Component) {
    (0, _inherits3.default)(SendButton, _React$Component);

    function SendButton() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SendButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SendButton.__proto__ || (0, _getPrototypeOf2.default)(SendButton)).call.apply(_ref, [this].concat(args))), _this), _this.onSendClick = function (ev) {
            var messageComposer = _this.props.messageComposer;

            if (messageComposer) {
                messageComposer._sendMessage();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SendButton, [{
        key: 'render',
        value: function render() {
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
            return _react2.default.createElement(AccessibleButton, { className: 'mx_MessageComposer_button mx_MessageComposer_send',
                onClick: this.onSendClick,
                title: (0, _languageHandler._t)('Send a message (unencrypted)…')
            });
        }
    }]);
    return SendButton;
}(_react2.default.Component);

exports.default = SendButton;
module.exports = exports['default'];
//# sourceMappingURL=SendButton.js.map